import axiosClient from "..";
class PosSaleCommissionAPI {
    static AllSaleCommissionPOS(page,filterPerpage,filter,idPredicate,filterId,percentagePredicate,filterPercentage,valuePredicate,filtervalue){
        return axiosClient.get(`/api/admin/pos/sale_commisions.json?page=${page}&per_page_count=${filterPerpage} ${filter && `&q[sale_id_${idPredicate}]=${filterId}&q[sale_commision_configuration_percentage_${percentagePredicate}]=${filterPercentage}&q[value_${valuePredicate}]=${filtervalue}`}`);
    }
}
export default PosSaleCommissionAPI;
